import { useState } from 'react';
import meetingImg from '@assets/images/Hero/contact-bg.png';
import { Handshake } from 'lucide-react';
import FillerModal from '@/components/Fillermodal';

export default function BookAppointment() {
  const [isFillerOpen, setIsFillerOpen] = useState(false);

  return (
    <>
      <section
        data-aos="fade-up"
        className="bg-white px-6 py-16 md:px-32 2xl:px-44"
      >
        {/* Content Container - Prevents over-stretching */}
        <div className="mx-auto max-w-7xl 2xl:max-w-[1200px]">
          {/* === Main Card === */}
          <div className="mx-auto flex flex-col overflow-hidden rounded-lg bg-[#0B0B0B] text-white shadow-xl md:flex-row md:items-center">
            {/* === Left: Image === */}
            <div className="w-full md:w-1/2 md:p-6 lg:p-8">
              <div className="overflow-hidden rounded-md shadow-md">
                <img
                  src={meetingImg}
                  alt="Team meeting"
                  className="h-64 w-full object-cover md:h-80 lg:h-72 2xl:h-80"
                />
              </div>
            </div>

            {/* === Right: Content === */}
            <div className="flex w-full flex-col items-center justify-center px-8 py-10 text-center md:w-1/2 md:items-center md:px-12 md:py-16 md:text-left">
              <h2 className="text-3xl font-extrabold tracking-tighter text-white sm:text-4xl">
                Book an <span className="text-[#FFBD59]">Appointment</span>
              </h2>

              <p className="mt-4 max-w-md px-10 text-center text-sm leading-relaxed text-white sm:text-base md:px-12 md:text-sm">
                Connect with our team to explore collaboration opportunities,
                share insights, or discuss how AeroComp's advanced composite
                solutions are shaping the future of ballistic protection and
                defense innovation in the Philippines.
              </p>

              <div className="mt-8">
                <button
                  onClick={() => window.open('/appointmentsystem', '_blank')}
                  className="flex items-center justify-center gap-2 rounded-md bg-[#FFBD59] px-12 py-4 text-sm  text-black shadow-md transition hover:bg-[#e6a949] hover:shadow-lg"
                >
                  <Handshake size={18} />
                  Connect with us
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* === Filler Modal === */}
      <FillerModal
        isOpen={isFillerOpen}
        onClose={() => setIsFillerOpen(false)}
        title="Ongoing Development!"
        message="Our APPOINTMENT SYSTEM is currently under development. You can reach us directly at"
        email="aerocompproject@gmail.com"
        gmailComposeLink="https://mail.google.com/mail/u/0/#inbox?compose=GTvVlcSHxGmQjXQnWhJtrZqMgWJkDwXkLXvtVLmgTtpxNNPBWtgszVBntflnSCmsfHsgqBfxBScxL"
      />
    </>
  );
}
